<template>
    <div class="traffic-content-main">
        <div class="Air-Charter">
            <div class="title">Air Charter</div>
            <div class="Air-Charter-center" v-show="viewportWidth > 799">
                <div class="content">
                    <div class="lable" v-for="item in airCharterList" :key="item.id">
                        <span class="lable-num"></span><div class="lable-content">{{item.content}}</div>
                    </div>
                </div>
            </div>
            <div v-show="viewportWidth <= 799">
                <div class="Air-Charter-center">
            </div>
            <div class="content">
                <div class="lable" v-for="item in airCharterList" :key="item.id">
                    <span class="lable-num"></span><div class="lable-content">{{item.content}}</div>
                </div>
            </div>
            </div>
        </div>
        <swiperComponent v-show="viewportWidth > 799"></swiperComponent>
            <swiperComponentPhone v-show="viewportWidth <= 799"></swiperComponentPhone>
            <div class="services">
                <div class="accommodations-list-item" v-for="(item,index) in servicesList" :key="item.id"  :ref="'serviceItem' + index">
                    <div class="left" :class="{'animateX': isVisible[index]}"><img loading="lazy"  :src="item.img" alt="" :class="{'banner-fade-in':isVisible[index]}"></div>
                    <div class="right" :class="{'animateRight': isVisible[index]}">
                        <div class="title">{{item.title}}</div>
                        <div class="desc">{{item.desc}}</div>
                    </div>
                </div>
            </div>
        <chartereSwiper></chartereSwiper>
        <montageImg :sightseeingInfo="sightseeingInfo" v-if="JSON.stringify(sightseeingInfo) != '{}'" :viewportWidth="String(viewportWidth)"></montageImg>
        <footerComponent></footerComponent>
    </div>
</template>
<script>
import airCharter from '/js/experience/traffic/airCharter'
import swiperComponent from '/components/pc/productContentComponent/swiperComponent/swiperComponent.vue'
import swiperComponentPhone from '/components/phone/productContentComponent/swiperComponent/swiperComponent.vue'
import accommodations from '/js/experience/accommodations/accommodations.js'
import services from '/js/experience/traffic/services.js'
import chartereSwiper from '/components/pc/experience/traffic/chartereSwiper.vue'
import footerComponent from '/components/pc/footerComponent/footerComponent.vue'
import sightseeing from '/js/experience/traffic/sightseeingInfo.js'
import montageImg from '/components/pc/experience/montageImg/montageImg.vue'
export default {
    components:{
        swiperComponent,
        swiperComponentPhone,
        chartereSwiper,
        footerComponent,
        montageImg
    },
    data(){
        return {
            airCharterList: airCharter.airCharterList,
            accommodationsList: accommodations.accommodationsList,
            servicesList: services.servicesList,
            sightseeingInfo:{},
            isVisible:[],
            viewportWidth:0,
        }
    },
    mounted(){
        this.viewportWidth = window.innerWidth;
        window.addEventListener('resize', this.handleResize);
        this.sightseeingInfo = sightseeing.sightseeingInfo
        this.servicesList.forEach((_, index) => {
            const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                // 设置当前元素为可见
                this.$set(this.isVisible, index, true);
                observer.unobserve(entry.target); // 停止观察该元素
                }
            });
            }, { threshold: 0.1 });

            // 获取当前索引的元素并开始观察
            const element = this.$refs['serviceItem' + index][0];
            observer.observe(element);
        });
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },
    methods:{
        handleResize(){
            this.viewportWidth = window.innerWidth;
        }
    }
}
</script>
<style scoped lang="scss">
@import '/style/pc/experience/traffic/traffic.scss';
@import '/style/phone/experience/traffic/traffic.scss';
@import '/style/pc/common/animateX.scss';
@import '/style/pc/common/animateRight.scss';
@import '/style/pc/common/fadeIn.scss';
</style>